import { paperTypeVars } from '../catalogHelpers';

export function setCurrentPage(currentPage, isPageLeft, isPageRight) {
    return {
        currentPage,
        isPageLeft: !!isPageLeft,
        isPageRight: !!isPageRight,
        type: 'SET_CURRENT_PAGE',
    };
}

export function setSinglePageDimensions(currentPageHeight, currentPageWidth) {
    return {
        dimensions: {
            height: currentPageHeight,
            width: currentPageWidth,
        },
        type: 'SET_PAGE_DIMENSIONS',
    };
}

export function loadTableContents() {
    return {
        type: 'LOAD_TABLE_CONTENTS',
    };
}

export function togglePageOverview() {
    return {
        type: 'TOGGLE_PAGE_OVERVIEW',
    };
}

export function toggleShareOptions() {
    return {
        type: 'TOGGLE_SHARE_OPTIONS',
    };
}

export function zoomIn(singlePageDimensions, pageCount) {
    return {
        pageCount,
        singlePageDimensions,
        type: 'ZOOM_IN',
    };
}

export function zoomOut() {
    return {
        type: 'ZOOM_OUT',
    };
}

export function turnOnDrag() {
    return {
        type: 'TURN_ON_DRAG',
    };
}

export function turnOffDrag() {
    return {
        type: 'TURN_OFF_DRAG',
    };
}

export function trackZoomDrag(cummulativeDragX, cummulativeDragY) {
    return {
        cummulativeDragX,
        cummulativeDragY,
        type: 'TRACK_ZOOM_DRAG',
    };
}

export function setPaperTypeVars(pageType) {
    return {
        ...paperTypeVars[pageType],
        type: 'SET_PAPER_TYPE_VARS',
    };
}

export function setErrorOccurred() {
    return {
        type: 'ERROR_OCCURRED',
    };
}

export function setScreenOrientation(screenOrientation) {
    return {
        screenOrientation,
        type: 'SET_SCREEN_ORIENTATION',
    };
}

export function displayRotateBanner() {
    return {
        type: 'DISPLAY_ROTATE_BANNER',
    };
}

export function hideRotateBanner() {
    return {
        type: 'HIDE_ROTATE_BANNER',
    };
}

export function toggleMenuBar() {
    return {
        type: 'TOGGLE_MENU_BAR',
    };
}

export function closeQuickViewModal() {
    return {
        type: 'CLOSE_QUICKVIEW_MODAL',
    };
}

export function openQuickViewModal(hotspot) {
    return {
        hotspot,
        type: 'OPEN_QUICKVIEW_MODAL',
    };
}

export function showQVSpinner() {
    return {
        type: 'SHOW_QUICKVIEW_SPINNER',
    };
}

export function hideQVSpinner() {
    return {
        type: 'HIDE_QUICKVIEW_SPINNER',
    };
}

export function setCurrentPhotoIndex(photoIndex) {
    return {
        currentPhotoIndex: photoIndex,
        type: 'SET_CURRENT_PHOTO_INDEX',
    };
}

export function setPhotoShape(photoShape) {
    return {
        photoShape,
        type: 'SET_PHOTO_SHAPE',
    };
}

export function setQuickViewImport(QuickViewImport) {
    return {
        QuickViewImport,
        type: 'SET_QUICK_VIEW_IMPORT',
    };
}

export function openSendToFriendModal() {
    return { type: 'OPEN_SEND_TO_FRIEND_MODAL' };
}

export function closeSendToFriendModal() {
    return { type: 'CLOSE_SEND_TO_FRIEND_MODAL' };
}
